import { Injectable } from '@angular/core';
import { HttpServices } from './http-service.service';
import { Message } from '../models/message.model'

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  constructor(private http: HttpServices) { }
  //#region Messages
  public sendUserMessage (message: Message)
  {
    return this.http.post('Messaging/SendUserMessage', message);
  }

  public sendAdminMessage (message: Message)
  {
    return this.http.post('Messaging/SendAdminMessage', message);
  }

  public getMessagingHistoryByRequestId(requestId: any)
  {
    return this.http.get('Messaging/GetMessagingHistory?reqId=' + requestId);
  }

  public getNewMessageDetailsByRequestId(requestId: any, isAdmin: boolean)
  {
    return this.http.get('Messaging/GetNewMessagDetails?reqId=' + requestId + '&isAdmin=' + isAdmin);
  }

  public getUserMessages(requestorId: any, pageIndex: any, pageSize: any, lang: any)
  {
    return this.http.get('Messaging/GetUserMessagesPaged?requestorId=' + requestorId + '&pageIndex='
    + pageIndex + "&pageSize=" + pageSize + "&lang=" + lang );
  }

  public getAdminMessages(adminMail: any, pageIndex: any, pageSize: any, lang: any)
  {
    return this.http.get('Messaging/GetAdminMessagesPaged?adminMail=' + adminMail + '&pageIndex='
    + pageIndex + "&pageSize=" + pageSize + "&lang=" + lang );
  }
  public getAdminUnreadMessages(adminMail: any, pageIndex: any, pageSize: any, lang: any)
  {
    return this.http.get('Messaging/GetAdminUnReadMessagesPaged?adminMail=' + adminMail + '&pageIndex='
    + pageIndex + "&pageSize=" + pageSize + "&lang=" + lang );
  }

  public markUserReceivedMessagesAsRead(requestId: any, userId: any)
  {
    return this.http.get('Messaging/MarkUserReceivedMessagesAsRead?reqId=' + requestId + '&userId=' + userId);
  }

  public markAdminReceivedMessagesAsRead(requestId: any, spGroupId: any)
  {
    return this.http.get('Messaging/MarkAdminReceivedMessagesAsRead?reqId=' + requestId + '&spGroupId=' + spGroupId);
  }
  //#endregion

  //#region ETenderMessages

  public sendUserETenderMessage (message: Message)
  {
    return this.http.post('ETenderMessaging/SendUserMessage', message);
  }

  public sendAdminETenderMessage (message: Message)
  {
    return this.http.post('ETenderMessaging/SendAdminMessage', message);
  }

  public getETenderMessagingHistoryByRequestId(requestId: any)
  {
    return this.http.get('ETenderMessaging/GetMessagingHistory?reqId=' + requestId);
  }

  public getETenderNewMessageDetailsByTenderId(tenderId: any, isAdmin: boolean, supplierId: any)
  {
    return this.http.get('ETenderMessaging/GetETenderNewMessagDetails?etenderId=' + tenderId + '&isAdmin=' + isAdmin + '&supplierId=' + supplierId);
  }

  public getUserETenderMessages(supplierId: any, pageIndex: any, pageSize: any, lang: any)
  {
    return this.http.get('ETenderMessaging/GetUserMessagesPaged?supplierId=' + supplierId + '&pageIndex='
    + pageIndex + "&pageSize=" + pageSize + "&lang=" + lang );
  }

  public getAdminETenderMessages(adminMail: any, pageIndex: any, pageSize: any, lang: any)
  {
    return this.http.get('ETenderMessaging/GetAdminMessagesPaged?adminMail=' + adminMail + '&pageIndex='
    + pageIndex + "&pageSize=" + pageSize + "&lang=" + lang );
  }

  public markUserReceivedETenderMessagesAsRead(requestId: any, userId: any)
  {
    return this.http.get('ETenderMessaging/MarkUserReceivedMessagesAsRead?etenderId=' + requestId + '&userId=' + userId);
  }

  public markAdminReceivedETenderMessagesAsRead(requestId: any, spGroupId: any)
  {
    return this.http.get('ETenderMessaging/MarkAdminReceivedMessagesAsRead?etenderId=' + requestId + '&spGroupId=' + spGroupId);
  }
  //#endregion

  public checkUserInSPGroup(email: any, groupName: any)
  {
    return this.http.get('SPGroupUser/CheckUserInSPGroup?email=' + email + '&groupName=' + groupName );
  }

  public CheckUserInMessagingSPGroups(email: any, requestId: any)
  {
    return this.http.get('SPGroupUser/CheckUserInMessagingSPGroups?email=' + email + '&reqId=' + requestId);
  }

}
